export default "__VITE_ASSET__8543aca0__"